export function isOvercrowded(slots: number) {
  return Math.sign(slots) === -1;
}
